<div class="gigaton-checkbox-label">
    <mat-checkbox [formControl]="activityControl" (change)="onChange($event)">
      <span  [innerHTML]="activity.checkboxLabel" ></span>
    </mat-checkbox>
<mat-error class="m-top-8" *ngIf="activityControl.touched && activityControl.hasError('required')"
    >{{ "Required" | translate }}*
  </mat-error>
</div>